import { render } from "./Icon.vue?vue&type=template&id=7d0c9ccb&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=ts"
export * from "./Icon.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-7d0c9ccb"

export default script